import { Box, Flex, Grid, Text } from '@lego/klik-ui';
import { TextHeader } from '@/components/common';
import type { DetailSectionProps } from '@/components/common/details/DetailsBox';
import { DocumentationLink } from '../DocumentationLink';

type Props = {
  section: DetailSectionProps;
};

export const DetailsSection = ({ section }: Props) => (
  <Box
    border={section.title ? '2px solid' : undefined}
    borderColor={section.title ? 'lightgrey' : undefined}
    borderRadius={section.title ? 'md' : undefined}
    mb={6}
    p={section.title ? 5 : undefined}
  >
    {section.title && <TextHeader tagLevel="h4" title={section.title} />}
    <Grid gap={4} templateColumns="repeat(auto-fill, minmax(300px, 1fr))">
      {Object.entries(section.items).map(([key, value]) => (
        <Grid.Item key={key} minWidth={0}>
          <Flex direction="row" gap={1}>
            <Text color="gray.500" fontSize="sm" fontWeight="medium">
              {key}
            </Text>
            <DocumentationLink url={value.documentationLink} />
          </Flex>
          <Text>{value.body}</Text>
        </Grid.Item>
      ))}
    </Grid>
  </Box>
);
